module.exports = "<router-outlet>\n  <app-notifications></app-notifications>\n</router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main